import React, { Component } from 'react';
import { Select, Input, Divider, Row, Checkbox, Button, message, Tag, InputNumber } from 'antd';
import { withDomains, RESTExecutor } from '../../../lib/domain';
import { schema_to_field, showErrorInNotification } from '../../../lib/util';
import Title from 'antd/lib/typography/Title';
import Form from '../../../lib/ui/form';
import ScheduleChanger from '../../../components/schedule_changer';


class HookAddEdit extends Component {
  constructor(props) {
    super(props)
  
    this.state = {
      form_data: this.props.edit_data || {},
      edit_id: this.props.edit_id,
      pluginsObj: {},
      pluginSchema: []
    }



    this.list_plugin = RESTExecutor.list().config({
      label: 'hooks',
      params: {
        pagination: false
      }
    }).callbacks((success) => {
      console.log("data",success.result);
      const result=success.result??{};

      let pluginsObj = {};

      result.rows.map((item) => {
        pluginsObj[item.id] = item
      });
      this.setState({
        pluginsObj: pluginsObj
      },()=>{
        if (this.props.edit_id) {
          this.setState({
            pluginSchema: schema_to_field(pluginsObj[this.props?.edit_data?.plugin_id]?.validation_config || {})
          })
        }
      });

     

    })
      .connect(props.domains.plugins);


    this.post_config = RESTExecutor.post().config({
      label: 'list'
    }).callbacks((success) => {
      message.success("Hook Added Successfully");
      typeof this.props.onClose === 'function' && this.props.onClose()

    }, (error) => {
      showErrorInNotification(error)
    }).connect(props.domains.hook);

    this.patch_config = RESTExecutor.patch().config({
      label: 'detail',
    }).callbacks((success) => {
      message.success("Hook Modified Successfully");
      typeof this.props.onClose === 'function' && this.props.onClose()


    }, (error) => {
      showErrorInNotification(error)
        }).connect(props.domains.hook);


  }
  

  stateUpdater = ({ stateKey, valueKey, value, appendObj = {}, callback }) => {
    let newData = this.state[stateKey];
    this.has_changed = true;
    if (valueKey) {
      newData[valueKey] = value;
    }
    if (appendObj) {
      Object.assign(newData, appendObj)
    }
    // console.log(newData);
    this.setState({
      [stateKey]: newData
    }, () => {
      typeof callback === 'function' && callback()
    })
  }


  handlePostPatch = () => {
    if (this.state.edit_id) {
      this.patch_config.forId(this.state.edit_id).execute(this.state.form_data)
    } else {
      this.post_config.execute(this.state.form_data);
    }
  }

  scheduleUpdater = ({ key, value }) => {
    let form_data = this.state.form_data;
    if (!form_data.schedule) {
      form_data.schedule = {}
    }
    form_data.schedule[key] = value;
    this.setState({
      form_data: form_data
    })
  }

  render() {
     const { pluginsObj, form_data, edit_id, source_id } = this.state;
    let schedule = form_data.schedule || {};

    // console.log("days list",day_list)
    return (
      <div>

        <div style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
            <Row type='flex' justify='center' style={{
            flex: 1
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              width: 'fit-content',
              textAlign: 'right',
              justifyContent: 'center'
            }}
            >
            
              <span>Hook Plugin: <Select style={{ width: 300 }}
                placeholder="Hook Plugin"
                filterOption={(input, option) => option.props.value.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                showSearch
                value={form_data.plugin_id}
                onChange={(value) => {
                  this.setState({
                    form_data:{
                      plugin_id:value
                    }
                  })
                  // this.stateUpdater({
                  //   stateKey: 'form_data', valueKey: 'plugin_id', value: value, callback: () => {
                  //     this.stateUpdater({ stateKey: 'form_data', valueKey: 'hook_parameters', value: {} })
                  //   }
                  // });
                  this.setState({
                    pluginSchema: schema_to_field(pluginsObj[value].validation_config || {})
                  })
                }}


              >
                {
                  Object.keys(pluginsObj).map((key, index) => {
                    let item = pluginsObj[key];
                    return <Select.Option value={item.id} key={item.id}>
                      {item.name}
                    </Select.Option>
                  })
                }

              </Select>
              </span>
            </div>
          </Row>
          <br></br>
          
          {this.state.pluginSchema.length > 0 ?
            <React.Fragment>
              <Divider style={{
                marginTop: 8,
                marginBottom: 8
              }} />

              <Title style={{ margin: 0 }} level={4} type='secondary'>Params</Title>
              <Form
                hideTitle
                forCreate={true}
                initialData={form_data || {}}
                submitted={this.state.submitted}
                onChange={(data) => {
                  console.log("Changes", data);
                  this.setState({
                    form_data:data
                  })
                  // this.stateUpdater({
                  //   stateKey: 'form_data',
                  //   valueKey: 'hook_parameters',
                  //   value: data,
                  // });
                }}
                fields={this.state.pluginSchema}
                submitting={{}}
                errorMessage={{}}
                validationErrors={{}}
              />
            </React.Fragment>
            : null}
          <br></br>
          <br></br>
          <Row type='flex' justify='space-between'>
            <div>
              <Button type='link' style={{ color: 'red' }} onClick={() => {
                typeof this.props.onClose === 'function' && this.props.onClose()
              }}>Cancel</Button>
            </div>
            <div>
              <Button type='primary' onClick={() => {
                this.handlePostPatch()
              }}>Submit</Button>
            </div>
          </Row>


        </div>

      </div>
    );
  }

  componentDidMount() {
    this.list_plugin.execute()
  }


  componentDidUpdate = (prevProps) => {
    if (this.props.edit_id !== prevProps.edit_id || this.props.edit_data !== prevProps.edit_data) {
      this.list_plugin.execute()
      this.setState({
        edit_id: this.props.edit_id,
        form_data: this.props.edit_data
      })
    };

  }
}

export default withDomains(HookAddEdit,'hook','plugins');
